import { FC } from "react";
import { ReasoningV1SessionPart } from "../session.types";
import styled from "@emotion/styled";
import { MDSSessionPartContainer } from "@/mds/components/sessions/session-parts/session-part.style";
import { SessionPartContext } from "@/mds/components/sessions/session-parts/session-part.types";

interface Props {
  part: ReasoningV1SessionPart;
  context: SessionPartContext;
}

export const MDSSessionReasoningV1Part: FC<Props> = ({ part }) => {
  return <Container>{part.summary}</Container>;
};

const Container = styled(MDSSessionPartContainer)`
  color: ${({ theme }) => theme.colors.chat.header};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
